import React, { useState, useEffect } from 'react';

const Header = ({ toggleSidebar }) => {
  const [activeDropdown, setActiveDropdown] = useState(null);

  const toggleDropdown = (dropdownName) => {
    setActiveDropdown(activeDropdown === dropdownName ? null : dropdownName);
  };

  const User = JSON.parse(localStorage.getItem("User"));


  const closeDropdowns = () => {
    setActiveDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If no dropdown is active, do nothing
      if (!activeDropdown) return;

      // Check if click is inside a dropdown menu or a toggle button
      if (
        !event.target.closest('.dropdown-menu') &&
        !event.target.closest('.header-link')
      ) {
        setActiveDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [activeDropdown]);

  // Dropdown data
  const languages = [
    { code: 'us', name: 'English', flag: '/New/assets/images/flags/us_flag.jpg' },
    { code: 'es', name: 'Spanish', flag: '/New/assets/images/flags/spain_flag.jpg' },
    { code: 'fr', name: 'French', flag: '/New/assets/images/flags/french_flag.jpg' },
    { code: 'de', name: 'German', flag: '/New/assets/images/flags/germany_flag.jpg' },
    { code: 'it', name: 'Italian', flag: '/New/assets/images/flags/italy_flag.jpg' },
    { code: 'ru', name: 'Russian', flag: '/New/assets/images/flags/russia_flag.jpg' },
  ];

  const cartItems = [
    { id: 1, name: 'SomeThing Phone', price: 1299.00, image: '/New/assets/images/ecommerce/jpg/1.jpg', specs: ['Metallic Blue', '6gb Ram'] },
    { id: 2, name: 'Stop Watch', price: 179.29, image: '/New/assets/images/ecommerce/jpg/3.jpg', specs: ['Analog'], badge: 'Free shipping' },
    { id: 3, name: 'Photo Frame', price: 29.00, image: '/New/assets/images/ecommerce/jpg/5.jpg', specs: ['Decorative'] },
    { id: 4, name: 'Kikon Camera', price: 4999.00, image: '/New/assets/images/ecommerce/jpg/4.jpg', specs: ['Black', '50MM'] },
    { id: 5, name: 'Canvas Shoes', price: 129.00, image: '/New/assets/images/ecommerce/jpg/6.jpg', specs: ['Gray', 'Sports'] },
  ];

  const notifications = [
    { id: 1, icon: 'ti-gift', iconBg: 'bg-primary-transparent', title: 'Your Order Has Been Shipped', description: 'Order No: 123456 Has Shipped To Your Delivery Address' },
    { id: 2, icon: 'ti-discount-2', iconBg: 'bg-secondary-transparent', title: 'Discount Available', description: 'Discount Available On Selected Products' },
    { id: 3, icon: 'ti-user-check', iconBg: 'bg-pink-transparent', title: 'Account Has Been Verified', description: 'Your Account Has Been Verified Successfully' },
    { id: 4, icon: 'ti-circle-check', iconBg: 'bg-warning-transparent', title: 'Order Placed ID: #1116773', description: 'Order Placed Successfully' },
    { id: 5, icon: 'ti-clock', iconBg: 'bg-success-transparent', title: 'Order Delayed ID: 7731116', description: 'Order Delayed Unfortunately' },
  ];

  const apps = [
    { name: 'Figma', icon: '/New/assets/images/apps/figma.png' },
    { name: 'Point', icon: '/New/assets/images/apps/microsoft-powerpoint.png' },
    { name: 'MS Word', icon: '/New/assets/images/apps/microsoft-word.png' },
    { name: 'Calendar', icon: '/New/assets/images/apps/calender.png' },
    { name: 'Sketch', icon: '/New/assets/images/apps/sketch.png' },
    { name: 'Docs', icon: '/New/assets/images/apps/google-docs.png' },
    { name: 'Google', icon: '/New/assets/images/apps/google.png' },
    { name: 'Translate', icon: '/New/assets/images/apps/translate.png' },
    { name: 'Sheets', icon: '/New/assets/images/apps/google-sheets.png' },
  ];

  const handleLogout = () => {
    localStorage.clear();
    document.cookie.split(";").forEach((c) => {
      document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date(0).toUTCString() + ";path=/");
    });
    window.location.href = "/";
  };

  const profileMenu = [
    { icon: 'ti-user-circle', label: 'Profile', href: '/profile' },
    // { icon: 'ti-inbox', label: 'Inbox', href: '/', badge: 25 },
    // { icon: 'ti-clipboard-check', label: 'Task Manager', href: '/', divider: true },
    // { icon: 'ti-adjustments-horizontal', label: 'Settings', href: '/' },
    { icon: 'ti-headset', label: 'Support', href: '/' },
    { icon: 'ti-logout', label: 'Log Out', action: handleLogout },
  ];

  // Dropdown Components
  const LanguageDropdown = () => (
    <div className={`dropdown-menu dropdown-menu-end ${activeDropdown === 'language' ? 'show' : ''}`} style={{ marginTop: '5%' }}>
      {languages.map((language) => (
        <a key={language.code} className="dropdown-item d-flex align-items-center" href="/">
          <span className="avatar avatar-xs lh-1 me-2">
            <img src={language.flag} alt={language.name} />
          </span>
          {language.name}
        </a>
      ))}
    </div>
  );

  const CartDropdown = () => (
    <div className={`dropdown-menu dropdown-menu-end ${activeDropdown === 'cart' ? 'show' : ''}`} style={{ marginTop: '5%' }}>
      <div className="p-3">
        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 fs-17 fw-semibold">Cart Items</p>
          <span className="badge bg-success-transparent">{cartItems.length} Items</span>
        </div>
      </div>
      <div className="dropdown-divider" />
      <ul className="list-unstyled mb-0">
        {cartItems.map((item) => (
          <li key={item.id} className="dropdown-item">
            <div className="d-flex align-items-start cart-dropdown-item">
              <img src={item.image} alt={item.name} className="avatar avatar-sm avatar-rounded br-5 me-3" />
              <div className="flex-grow-1">
                <div className="d-flex align-items-start justify-content-between mb-0">
                  <div className="mb-0 fs-13 text-dark fw-semibold">
                    <a href="/">{item.name}</a>
                  </div>
                  <div>
                    <span className="text-black mb-1">${item.price.toLocaleString()}</span>
                    <a href="/" className="header-cart-remove float-end">
                      <i className="ti ti-trash" />
                    </a>
                  </div>
                </div>
                <div className="min-w-fit-content d-flex align-items-start justify-content-between">
                  <ul className="header-product-item d-flex">
                    {item.specs.map((spec, index) => (
                      <li key={index}>{spec}</li>
                    ))}
                    {item.badge && (
                      <li>
                        <span className="badge bg-pink-transparent fs-10">{item.badge}</span>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <div className="p-3 border-top">
        <div className="d-grid">
          <a href="/" className="btn btn-primary">Proceed to checkout</a>
        </div>
      </div>
    </div>
  );

  const NotificationsDropdown = ({ className }) => (
    <div className={`dropdown-menu dropdown-menu-end ${activeDropdown === 'notifications' ? 'show' : ''} ${className}`} style={{ marginTop: '5%' }}>
      <div className="p-3">
        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 fs-17 fw-semibold">Notifications</p>
          <span className="badge bg-secondary-transparent">5 Unread</span>
        </div>
      </div>
      <div className="dropdown-divider" />
      <ul className="list-unstyled mb-0">
        {notifications.map((notification) => (
          <li key={notification.id} className="dropdown-item">
            <div className="d-flex align-items-start">
              <div className="pe-2">
                <span className={`avatar avatar-md ${notification.iconBg} avatar-rounded`}>
                  <i className={`ti ${notification.icon} fs-18`} />
                </span>
              </div>
              <div className="flex-grow-1">
                <p className="mb-0 fw-semibold">
                  <a href="/">{notification.title}</a>
                </p>
                <span className="text-muted fw-normal fs-12 header-notification-text">
                  {notification.description}
                </span>
              </div>
            </div>
          </li>
        ))}
      </ul>
      <div className="p-3 border-top">
        <div className="d-grid">
          <a href="/" className="btn btn-primary">View All</a>
        </div>
      </div>
    </div>
  );

  const AppsDropdown = () => (
    <div className={`dropdown-menu dropdown-menu-end pb-0 ${activeDropdown === 'apps' ? 'show' : ''}`} style={{ marginTop: '5%' }}>
      <div className="p-3">
        <div className="d-flex align-items-center justify-content-between">
          <p className="mb-0 fs-17 fw-semibold">Related Apps</p>
        </div>
      </div>
      <div className="dropdown-divider mb-0" />
      <div className="main-header-shortcuts p-2">
        <div className="row g-2">
          {apps.map((app, index) => (
            <div key={index} className="col-4">
              <a href="/">
                <div className="text-center p-3 related-app">
                  <span className="avatar avatar-sm avatar-rounded">
                    <img src={app.icon} alt={app.name} />
                  </span>
                  <span className="d-block fs-12">{app.name}</span>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
      <div className="p-3 border-top">
        <div className="d-grid">
          <a href="/" className="btn btn-primary">View All</a>
        </div>
      </div>
    </div>
  );

  const ProfileDropdown = ({ className }) => (
    <ul className={`dropdown-menu pt-0 overflow-hidden header-profile-dropdown dropdown-menu-end mt-5 ${activeDropdown === 'profile' ? 'show' : ''} ${className}`}>
      {profileMenu.map((item, index) => (
        <React.Fragment key={index}>
          <li>
            <a
              className={`dropdown-item d-flex ${item.divider ? 'border-block-end' : ''}`}
              href={item.href || '#'}
              onClick={(e) => {
                if (item.action) {
                  e.preventDefault();
                  item.action();
                }
              }}
            >
              <i className={`ti ${item.icon} fs-18 me-2 op-7`} />
              {item.label}
              {item.badge && <span className="badge bg-success-transparent ms-auto">{item.badge}</span>}
            </a>
          </li>
          {item.divider && <div className="dropdown-divider" />}
        </React.Fragment>
      ))}
    </ul>
  );

  return (
    <header className="app-header" >
      <div className="main-header-container container-fluid">
        {/* Left Section */}
        <div className="header-content-left">
          <div className="header-element">
            <div className="horizontal-logo">
              <a href="/" className="header-logo">
                <img src="/New/assets/images/brand-logos/desktop-logo.png" alt="logo" className="desktop-logo" />
                <img src="/New/assets/images/brand-logos/toggle-logo.png" alt="logo" className="toggle-logo" />
                <img src="/New/assets/images/brand-logos/desktop-dark.png" alt="logo" className="desktop-dark" />
                <img src="/New/assets/images/brand-logos/toggle-dark.png" alt="logo" className="toggle-dark" />
                <img src="/New/assets/images/brand-logos/desktop-white.png" alt="logo" className="desktop-white" />
                <img src="/New/assets/images/brand-logos/toggle-white.png" alt="logo" className="toggle-white" />
              </a>
            </div>
          </div>

          <div className="header-element">
            <a className="sidemenu-toggle header-link sidenav-toggled animated-arrow hor-toggle horizontal-navtoggle"
              href="#" aria-label="Hide Sidebar" onClick={toggleSidebar} >
              <span />
            </a>
          </div>

        </div>

        {/* Right Section */}
        <div className="header-content-right">

          {/* Notifications */}
          <div className="header-element notifications-dropdown">
            <a
              className="header-link dropdown-toggle"
              onClick={() => toggleDropdown('notifications')}>
              <i className="bx bx-bell header-link-icon" />
              <span className="badge bg-secondary rounded-pill header-icon-badge pulse pulse-secondary">
                10
              </span>
            </a>
            <NotificationsDropdown className="dropdown-space-top" />
          </div>

          {/* Profile */}
          <div className="header-element">
            <a
              className="header-link dropdown-toggle"
              onClick={() => toggleDropdown('profile')}>
              <div className="d-flex align-items-center">
                <div className="me-sm-2 me-0">
                  <img src="/New/assets/images/faces/9.jpg" alt="Profile" width={32} height={32} className="rounded-circle" />
                </div>
                <div className="d-sm-block d-none">
                  <p className="fw-semibold mb-0 lh-1 text-light">{User?.name}</p>
                  <span className="op-7 fw-normal d-block fs-11"></span>
                </div>
              </div>
            </a>
            <ProfileDropdown className="dropdown-space-top1" />
          </div>

          {/* Settings */}
          <div className="header-element">
            <a href="/" className="header-link switcher-icon"
              data-bs-toggle="offcanvas" data-bs-target="#switcher-canvas">
              <i className="bx bx-cog header-link-icon" />
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;